import { reportOaConstants } from "../constants";

export const getReportOa = (data) => {
    return {
        type: reportOaConstants.GET_REPORT_OA,
        data
    }
}